

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import exact from 'prop-types-exact';
import SearchArtists from '../containers/SearchArtistsContainer';
import ArtistsSlider from '../containers/ArtistsSliderContainer';
// import Banner from '../../../common/Banner/Banner';
import Placeholder from '../../../common/placeholder/Placeholder';

// const topBannerConfig = {
//     // title: 'PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-artists-top_multi_sizes',
//     sizes: [[970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [320, 50], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [300, 100], [320, 50], [234, 60]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

// const firstLeaderboardBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-artists-first_leaderboard-multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [320, 50], [336, 280], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

// const secondLeaderboardBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-artists-second_leaderboard-multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

// const thirdLeaderboardBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-artists-third_leaderboard-multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

const ArtistsComponent = (props) => {
    useEffect(() => {
        props.fetchDataArtistsIfNeeded();

        animateScrollTo(0, { speed: 700 });
    });


    // @TODO: add the placeholders in their respective components
    return (
        <section className="sectionArtists">
            {/* <Banner key={topBannerConfig.adUnit} config={topBannerConfig} /> */}
            <header>
                <h1>Conheça tudo sobre o seu artista favorito</h1>
                <p className="tw-text-black tw-text-center">Beyoncé, Bruno Mars, Coldplay, Céline Dion, Imagine Dragons e muito mais</p>
            </header>
            {props.dataArtists.length > 0
                ? <SearchArtists dataArtists={props.dataArtists} />
                : <Placeholder minHeight="200px" />}
            <ArtistsSlider autoPlay />
            {/* <Banner key={firstLeaderboardBannerConfig.adUnit} config={firstLeaderboardBannerConfig} /> */}
        </section>
    );
};

ArtistsComponent.propTypes = exact({
    dataArtists: PropTypes.arrayOf(PropTypes.object).isRequired,
    fetchDataArtistsIfNeeded: PropTypes.func.isRequired,
});

export default ArtistsComponent;
